<template>
  <div id="container">
    <el-container>
      <el-header>
        <common-header />
      </el-header>
      <el-container style="height: calc(100vh - 60px);" >
       <!--  <el-aside width="auto" class="no-scroll">
          <common-menu-aside class="drawer-container" />
        </el-aside> -->
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import CommonMenuAside from "../components/menu/CommonMenuAside.vue";
import CommonHeader from "../components/header/CommonHeader.vue";
import CommonFooter from "../components/footer/CommonFooter.vue";
export default {
  data() {
    return {
    };
  },
  components: {
    CommonMenuAside,
    CommonHeader,
    CommonFooter,
  },
};
</script>

<style lang="less" scoped>
.no-scroll::-webkit-scrollbar {
  display: none;
}

.no-scroll {
  -ms-overflow-style: none;
  /* IE */
  scrollbar-width: none;
  /* Firefox */
}

#container {
  background-color: #f4f4f4;
}

.el-header {
  padding: 0;
}

.el-footer {
  padding: 0;
}

.el-main {
  padding: 20px;
  margin: 20px;
  border-radius: 20px;
  background-color: #fff;
  flex: 1;
  overflow: auto;
}
</style>
